import { DeepPartial } from '@fullstory/typeutils';
import { AppState } from '@fullstory/redux';
import {
  mockJourneyDetail,
  mockJourneyDetailWithHiddenPageEvents,
  mockJourneyDetailWithHiddenNamedElements,
} from './util';

export const mockInitialSavedJourneysState: DeepPartial<AppState> = {
  journeyMaps: {
    journeys: {
      12: mockJourneyDetail,
    },
    allJourneys: {
      lastRequested: 0,
      lastResponded: 0,
      loading: false,
      error: false,
      data: {
        journeys: [mockJourneyDetail],
      },
    },
    unnamedJourney: {
      hash: 'unnamedHash',
      journey: {
        journey: mockJourneyDetail.journey?.journeyMap!,
      },
    },
  },
};
export const mockInitialWithHiddenPageEventsSavedJourneysState: DeepPartial<AppState> = {
  journeyMaps: {
    journeys: {
      13: mockJourneyDetailWithHiddenPageEvents,
    },
    allJourneys: {
      lastRequested: 0,
      lastResponded: 0,
      loading: false,
      error: false,
      data: {
        journeys: [mockJourneyDetailWithHiddenPageEvents],
      },
    },
  },
};

export const mockInitialWithHiddenNamedElementsSavedJourneysState: DeepPartial<AppState> = {
  journeyMaps: {
    journeys: {
      14: mockJourneyDetailWithHiddenNamedElements,
    },
    allJourneys: {
      lastRequested: 0,
      lastResponded: 0,
      loading: false,
      error: false,
      data: {
        journeys: [mockJourneyDetailWithHiddenNamedElements],
      },
    },
  },
};
